import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import Etoday from './investComponents/Etoday.vue';
import PowerGenerationRevenue from './investComponents/PowerGenerationRevenue.vue';
import PrepareRate from './investComponents/PrepareRate.vue';
import PerformantRate from './investComponents/PR.vue';
import Monitor from './investComponents/Monitor.vue';
import DataRetention from './investComponents/DataRetention.vue';
import { isDateAfterToday } from '@/utils/datetime';

import { DateTime } from 'luxon';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'InvestmentAnalysis',
  components: {
    Etoday: Etoday,
    PowerGenerationRevenue: PowerGenerationRevenue,
    PrepareRate: PrepareRate,
    PerformantRate: PerformantRate,
    Monitor: Monitor,
    DataRetention: DataRetention
  },
  data: function data() {
    return {
      chartTitle: '發電量',
      activeOrder: 0,
      datepickerDate: DateTime.local().minus({
        months: 11
      }).toFormat('yyyy-MM'),
      beginDate: DateTime.local().minus({
        months: 11
      }).toFormat('yyyy-MM'),
      endDate: DateTime.local().toFormat('yyyy-MM'),
      searchDateArr: [],
      chooseDate: false,
      confirmButton: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryData'])), {}, {
    currentComponentName: function currentComponentName() {
      switch (this.chartTitle) {
        case '發電量':
          return 'Etoday';
        case '發電收入':
          return 'PowerGenerationRevenue';
        case '妥善率':
          return 'PrepareRate';
        case 'PR值':
          return 'PerformantRate';
        case '監控值與電費單比較':
          return 'Monitor';
        default:
          return 'DataRetention';
      }
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations(['changeDataAnalysisLang'])), mapActions(['asyncLastSingleDoc'])), {}, {
    isDateAfterToday: isDateAfterToday,
    selectAnalysis: function selectAnalysis(selected, routerName) {
      var _this = this;
      this.activeOrder = selected;
      this.chartTitle = routerName;
      this.$nextTick(function () {
        return _this.buttonConfirm();
      });
    },
    buttonConfirm: function buttonConfirm() {
      this.buildSearchDate();
      switch (this.chartTitle) {
        case '發電量':
          this.$refs.Etoday.getEtodayData(this.searchDateArr);
          break;
        case '發電收入':
          this.$refs.PowerGenerationRevenue.getEtodayData(this.searchDateArr);
          break;
        case '妥善率':
          this.$refs.PrepareRate.getAvailability(this.searchDateArr);
          break;
        case 'PR值':
          this.$refs.PerformantRate.getPrData(this.searchDateArr);
          break;
        case '資料妥善率':
          this.$refs.DataRetention.getRetention(this.searchDateArr);
          break;
      }
    },
    buildSearchDate: function buildSearchDate() {
      this.searchDateArr = [];
      if (this.chooseDate) {
        var diff = DateTime.fromISO(this.endDate).diff(DateTime.fromISO(this.beginDate), 'months').months;
        if (diff < 0) {
          this.$swal('請選擇正確區間');
          return;
        }
        for (var i = 0; i <= diff; i++) {
          this.searchDateArr.push(DateTime.fromISO(this.beginDate).plus({
            months: i
          }).toFormat('yyyy-MM'));
        }
      } else {
        for (var _i = 0; _i < 12; _i++) {
          this.searchDateArr.push(DateTime.fromISO(this.datepickerDate).plus({
            months: _i
          }).toFormat('yyyy-MM'));
        }
      }
    }
  }),
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this2.factoryData.length) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this2.asyncLastSingleDoc(_this2.$route.query.siteName);
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.buttonConfirm();
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};